var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoLeafinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 57",
    id: "co-leaf_inline_svg__svg98"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "co-leaf_inline_svg__defs88"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "co-leaf_inline_svg__a",
    x: 0,
    y: 0,
    width: 123,
    height: 123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    id: "co-leaf_inline_svg__feOffset77"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b",
    id: "co-leaf_inline_svg__feGaussianBlur79"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    id: "co-leaf_inline_svg__feFlood81"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b",
    id: "co-leaf_inline_svg__feComposite83",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "result1",
    id: "co-leaf_inline_svg__feComposite85"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style75"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207.552 -3463.187)",
    id: "co-leaf_inline_svg__g96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.762 513.2s12.521-21.309 34.889-26.65c0 0-17.2 6.38-27.4 19.463 0 0 12.289 6.461 19.446.688 7.157-5.773 14.21-23.71 27.072-24.4 0 0-42.923-13.91-48.923 21.643 0 0-5.613 5.953-7.21 8.749a1.177 1.177 0 002.123.5",
    id: "co-leaf_inline_svg__path94",
    transform: "translate(-422.639 2995.379)",
    fill: "#00993b"
  }))));
}

export default SvgCoLeafinline;